<template>
  <div class="guidedToursPage">
    <Banners page="guided_tour" />
    <Breadcrumbs v-if="!isHome">
      <span>{{ getNavName('NAV_GUIDED_TOURS') }}</span>
    </Breadcrumbs>
    <div class="guidedTours">
      <Loading :visible="isLoading" size="large" type="fullPage"></Loading>

      <div class="pageHeader">
        <VenueFilter
          v-if="isLoaded && ready"
          class="filter"
          v-bind:class="['filterCount-' + filterCount]"
        />
        <div
          class="categories filter"
          v-bind:class="['filterCount-' + filterCount]"
          v-if="categories.length > 0 && canShowCategories"
        >
          <CheckInput
            type="button"
            class="category"
            v-for="category in categories"
            :key="category.name"
            :fname="category.id"
            :model-value="category.selected"
            @update:model-value="(v) => setCategoryFilterLocal(category.id, v)"
            :label="category.name"
          ></CheckInput>
        </div>
        <div
          class="languages filter"
          v-bind:class="['filterCount-' + filterCount]"
          v-if="Object.keys(selectedLanguages).length > 1"
        >
          <CheckInput
            type="button"
            class="language"
            v-for="(lang, key) in selectedLanguages"
            :key="lang.name"
            :fname="key"
            :disabled="lang.selected"
            :model-value="lang.selected"
            @update:model-value="(v) => setLanguageFilterLocal(key, v)"
            :label="lang.name"
          ></CheckInput>
        </div>
        <ListDates class="filter" v-bind:class="['filterCount-' + filterCount]" />
      </div>

      <div class="tours" v-if="!isLoading">
        <transition-group
          name="fade"
          v-if="Object.keys(filteredGuidedTours).length"
          tag="div"
          class="tourContainer"
        >
          <template :key="tour.id" v-for="tour in filteredGuidedTours">
            <GuidedTourListItem :item="tour" />
          </template>
        </transition-group>
      </div>
      <div
        v-if="Object.keys(filteredGuidedTours).length === 0 && isLoaded && !isLoading"
        class="noItems"
      >
        <h2>{{ $t('GUIDED_TOURS_NO_TOURS') }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import truncate from 'html-truncate';
import Loading from '../Loading.vue';
import Breadcrumbs from '../Breadcrumbs.vue';
import CheckInput from '../Form/CheckInput.vue';
import VenueFilter from './VenueFilter.vue';
import Banners from '../Banners/Banners.vue';
import ListDates from './ListDates.vue';
import { setPageTitle } from '../../lib/pageTitle';
import GuidedTourListItem from './GuidedTourListItem.vue';
import { useSeoMeta } from '@unhead/vue';

export default {
  name: 'GuidedTours',
  components: {
    GuidedTourListItem,
    Loading,
    Breadcrumbs,
    CheckInput,
    VenueFilter,
    Banners,
    ListDates,
  },
  data() {
    return {
      ready: false,
      canShowCategories: false,
    };
  },
  props: {
    isHome: { default: false },
  },
  computed: {
    ...mapState({
      currencySymbol: (state) => state.app.currencySymbol,
      isLoading: (state) => state.guidedTours.isLoadingList,
      isLoaded: (state) => state.guidedTours.isLoadedList,
      publicURL: (state) => state.app.API_PUBLIC_URL,
      language: (state) => state.language,
      selectedLanguages: (state) => state.guidedTours.selectedLanguages,
      categories: (state) => state.guidedTours.categories,
      meta: (state) => state.meta.data,
      selectedDay: (state) => state.guidedTours.selectedDay,
      navTranslations: (state) => state.app.navTranslations,
      hasMultipleVenues: (state) => state.guidedTours.hasMultipleVenues,
    }),
    ...mapGetters({
      filteredGuidedTours: 'guidedTours/filteredList',
    }),
    filterCount() {
      let c = 0;
      if (this.hasMultipleVenues) {
        c += 1;
      }
      if (Object.keys(this.selectedLanguages).length > 1) {
        c += 1;
      }
      if (this.categories.length) {
        c += 1;
      }
      /*if (this.isToursPerDateLoaded) {
        c += 1;
      }*/
      return c;
    },
  },

  methods: {
    ...mapActions({
      listGuidedTours: 'guidedTours/list',
      listGuidedToursPerDay: 'guidedTours/listPerDay',
      listGuidedTourCategories: 'guidedTours/listCategories',
      setLanguageFilter: 'guidedTours/setLanguageFilter',
      setCategoryFilter: 'guidedTours/setCategoryFilter',
      clearEmptyCategories: 'guidedTours/clearEmptyCategories',
      setSelectedDay: 'guidedTours/setSelectedDay',
    }),
    getNavName(type) {
      if (typeof this.navTranslations !== 'undefined') {
        if (typeof this.navTranslations[type] !== 'undefined') {
          if (
            typeof this.navTranslations[type][this.language] !== 'undefined' &&
            this.navTranslations[type][this.language] !== ''
          ) {
            return this.navTranslations[type][this.language];
          }
        }
      }
      return this.$t(type);
    },
    setLanguageFilterLocal(key, v) {
      this.setLanguageFilter({ [key]: v });
      this.setUrlQuery();
    },
    setCategoryFilterLocal(key, v) {
      this.setCategoryFilter({ id: key, selected: v });
      this.setUrlQuery();
    },
    setUrlQuery() {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query.category = [];
      query.language = [];
      Object.keys(this.categories).forEach((c) => {
        const category = this.categories[c];
        if (category.selected) {
          query.category.push(category.name);
        }
      });

      Object.keys(this.selectedLanguages).forEach((l) => {
        const language = this.selectedLanguages[l];
        if (language.selected) {
          query.language.push(language.name);
        }
      });

      this.$router.replace({ query });
    },
    parseQuery() {
      let queryCategories = [];
      let queryLanguages = [];

      if (!Array.isArray(this.$route.query.category)) {
        queryCategories.push(this.$route.query.category);
      } else {
        queryCategories = this.$route.query.category;
      }
      queryCategories.forEach((qc) => {
        const category = this.categories.find((c) => qc === c.name);
        if (typeof category !== 'undefined') {
          this.setCategoryFilter({ id: category.id, selected: true });
        }
      });

      if (!Array.isArray(this.$route.query.language)) {
        if (typeof this.$route.query.language !== 'undefined') {
          queryLanguages.push(this.$route.query.language);
        }
      } else {
        queryLanguages = this.$route.query.language;
      }
      queryLanguages.forEach((ql) => {
        const id = Object.keys(this.selectedLanguages).find(
          (l) => ql === this.selectedLanguages[l].name
        );
        if (typeof id !== 'undefined') {
          this.setLanguageFilter({ [id]: true });
        }
      });
    },
    truncateHtml(html) {
      if (typeof html !== 'undefined') {
        return truncate(html, 150);
      }
      return false;
    },
    setMeta() {
      let title = '';
      let description = '';
      let keywords = '';
      let image = '';
      if (typeof this.meta !== 'undefined') {
        if (typeof this.meta.guided_tour !== 'undefined') {
          description = this.meta.guided_tour.description;
          keywords = this.meta.guided_tour.keywords;
          if (this.meta.guided_tour.image) {
            image = `${this.publicURL}1200/${this.meta.guided_tour.image}`;
          }
          title = this.meta.guided_tour.title;
        }

        useSeoMeta({
          title: setPageTitle(title),
          ogTitle: setPageTitle(title),
          description,
          keywords,
          ogDescription: description,
          ogImage: image,
        });
      }
    },
  },
  watch: {
    meta() {
      this.setMeta();
    },
  },
  mounted() {
    /*const today = moment().format('YYYY-MM-DD');
    let day = today;
    if (this.selectedDay) {
      day = this.selectedDay;
    } else if (typeof this.$route.query.date !== 'undefined') {
      day = this.$route.query.date;
    }
    this.listGuidedToursPerDay({ day: today, lookahead: 4 }).then(() => {
      if (day !== today) {
        this.listGuidedToursPerDay({ day, lookahead: 0 }).then(() => {
          this.setSelectedDay(day);
        });
      }
    });
    */
    Promise.all([this.listGuidedTourCategories(), this.listGuidedTours()]).then(() => {
      this.clearEmptyCategories();
      this.canShowCategories = true;
      this.parseQuery();
      this.ready = true;
    });
    this.setMeta();
  },
};
</script>

<style scoped lang="scss">
@import '../../scss/buttons';
@import '../../scss/mixins';
@import '../../scss/grid';

.guidedTours {
  //@extend .container-fluid;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;

  background-color: $block-color;
  @include blockPadding;
}

.pageHeader {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: $sp;
  margin-bottom: 4 * $sp;
  align-content: center;

  .filter {
    flex-basis: auto;
    flex-shrink: 1;
    flex-grow: 1;
    flex-wrap: wrap;
    background-color: $secondary-block-color-1;
    padding: $sp;
    text-align: center;
    display: flex;
    flex-direction: row;
    gap: $sp;
    button,
    :deep(.checkInputSingle) {
      margin-bottom: 0 !important;
    }
    @media screen and (max-width: $screen-sm) {
      justify-content: center !important;
    }
  }
  .filter.filterCount-1 {
    background-color: transparent;
    padding: 0;
  }
}

.noItems {
  text-align: center;
  padding-top: 5 * $sp;
  padding-left: $sp;
  padding-right: $sp;
  color: $brand-lighter;
}
.tours {
  @extend .row;
  clear: both;
  > .tourContainer {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
